window.CustomerEmailStorage = {
  storageKey: 'weatherstrong_customer_email',

  get() {
    const loggedInEmail =
      window.WeatherStrongCustomerEmail || '';

    if (loggedInEmail.trim()) {
      return loggedInEmail.trim();
    }

    try {
      return localStorage.getItem(this.storageKey) || '';
    } catch (error) {
      console.warn('Failed to read customer email.', error);
      return '';
    }
  },

  set(email) {
    const value =
      typeof email === 'string'
        ? email.trim()
        : '';

    if (!value) {
      return false;
    }

    try {
      localStorage.setItem(this.storageKey, value);
      return true;
    } catch (error) {
      console.warn('Failed to save customer email.', error);
      return false;
    }
  }
};